import { useEffect, useRef, useState } from 'react';
import './ScratchCard.css';
import { getDocument, updateDocument } from '../../firebase-functions/database';
import { v4 as uuidv4 } from 'uuid';
import { auth } from '../../firebase-functions/config';
import { toast } from 'react-toastify';

// --- Scratch Card Component ---

const goldRewardsTable = [
  {
    type: 'gold',
    name: 'gold',
    value: 2000,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1000,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 2000,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 10,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 12,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 10,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 12,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 15,
  },

  {
    type: 'robux',
    name: 'robux',
    value: 10,
  },

  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 3,
  },
  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 2,
  },
  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 2,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 2,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 3,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 2,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 2,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 3,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 2,
  },
  {
    type: 'wordPotion',
    name: 'Word Potion',
    value: 2,
  },
  {
    type: 'wordPotion',
    name: 'Word Potion',
    value: 2,
  },

  {
    type: 'coupon',
    name: '% off',
    value: 50,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 50,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 60,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 70,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 80,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 90,
  },
];

const silverRewardsTable = [
  {
    type: 'gold',
    name: 'gold',
    value: 200,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 300,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 400,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1000,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 200,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 300,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 400,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1000,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 200,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 300,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 400,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 300,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 400,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 300,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 400,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 500,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 1000,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 7,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 5,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 1,
  },
  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 1,
  },
  {
    type: 'bookOfTimeTravel',
    name: 'Book of Time Travel',
    value: 1,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 1,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 1,
  },
  {
    type: 'bookOfHistory',
    name: 'Book of History',
    value: 1,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 1,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 1,
  },
  {
    type: 'bookOfQuest',
    name: 'Book of Quest',
    value: 1,
  },
  {
    type: 'wordPotion',
    name: 'Word Potion',
    value: 1,
  },
  {
    type: 'wordPotion',
    name: 'Word Potion',
    value: 1,
  },

  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 50,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 50,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 30,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 40,
  },
  {
    type: 'coupon',
    name: '% off',
    value: 50,
  },
];

const bronzeRewardsTable = [
  {
    type: 'gold',
    name: 'gold',
    value: 100,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 50,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 50,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 40,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 50,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 100,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 50,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 30,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 20,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 100,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 10,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 10,
  },
  {
    type: 'gold',
    name: 'gold',
    value: 10,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 1,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 3,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 2,
  },
  {
    type: 'robux',
    name: 'robux',
    value: 1,
  },
];

const rewardImg = {
  gold: 'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_2.png?alt=media&token=b18097b0-407b-4668-88e1-fb7e4e2f3696',
  robux:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FRobux_2019_Logo_gold.svg.png?alt=media&token=42ab7d0d-53e1-41f9-8f30-c953c6493e3a',
  bookOfTimeTravel:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Everything.png?alt=media&token=a29e8976-ddcf-42bb-a4f0-9cf36114341e',
  bookOfHistory:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Heroes.png?alt=media&token=fd103eaa-458c-4273-82eb-ff1fb3e0e624',
  bookOfQuest:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Book_of_Troops.png?alt=media&token=bacec6ad-1da8-4386-9ffa-8adf91ae600b',
  wordPotion:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FMagic_Item_Power_potion.png?alt=media&token=af882f44-96a2-4a63-8b26-b8d4a3239893',
  coupon:
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2Fcoupon.webp?alt=media&token=8c9eaac5-4133-4ab7-ac44-efb7e123f33f',
};

export const ScratchCard = ({ onClose, readerId, tier }) => {
  const [isLoading, setIsLoading] = useState(true); // Preloader State
  const [isSpinning, setIsSpinning] = useState(false); // Controls Animation (starts after load)
  const [hasScratched, setHasScratched] = useState(false); // Controls Prize Visibility
  const [reward, setReward] = useState();

  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const isRevealedRef = useRef(false); // Track internal reveal state

  // WORKAROUND: Grid tracking instead of Pixel tracking
  // We divide the 240x240 canvas into a grid to track scratched areas without reading image data
  const scratchedGridRef = useRef(new Set());

  const frontImgUrl =
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsctatch-card%2Fscratch%20card-front.webp?alt=media&token=0c3fc76f-2c17-4bd3-88d9-b9d76a173b57';

  const backImgUrl =
    tier === 'gold'
      ? 'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsctatch-card%2Fscratch%20card.webp?alt=media&token=8d0772d8-29fa-4b57-b19a-29172bdf274c'
      : tier === 'silver'
        ? 'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsctatch-card%2Fscratch%20card-silver.webp?alt=media&token=682603fc-d337-4bea-a05e-b899f3626412'
        : 'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsctatch-card%2Fscratch%20card-bronze.webp?alt=media&token=cbb1eba5-d2c1-411b-8964-b7247669761a';
  const scratchSurfaceUrl =
    'https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fsctatch-card%2Fscratch%20card-front-scratchable.webp?alt=media&token=a6ea72f8-d8f5-45a0-9861-a841fd1f4e45';

  // --- REWARD HANDLER ---
  const handleReward = () => {
    // TODO: Add your custom reward logic here.
    if (!reward) {
      return;
    }

    getDocument('demoReaders', readerId).then((resReader) => {
      if (!resReader.success) {
        toast.error("Couldn't fetch the reader Data");
        return;
      }

      let readerProfile = resReader.data;

      if (readerProfile.scratchCard === 'none') {
        toast.error('reward already claimed');
        onClose();
        return;
      }

      if (reward.type === 'gold') {
        if (readerProfile.starDeduction) {
          readerProfile.starDeduction =
            readerProfile.starDeduction - reward.value;
        } else {
          readerProfile.starDeduction = reward.value * -1;
        }
      }
      if (reward.type === 'robux') {
        readerProfile.robux = readerProfile.robux - reward.value;
      }

      if (reward.type === 'bookOfHistory') {
        if (
          readerProfile.inventory.bookOfHistory &&
          typeof readerProfile.inventory.bookOfHistory === 'number'
        ) {
          readerProfile.inventory.bookOfHistory =
            readerProfile.inventory.bookOfHistory + reward.value;
        } else {
          readerProfile.inventory.bookOfHistory = reward.value;
        }
      }

      if (reward.type === 'bookOfTimeTravel') {
        if (
          readerProfile.inventory.bookOfTimeTravel &&
          typeof readerProfile.inventory.bookOfTimeTravel === 'number'
        ) {
          readerProfile.inventory.bookOfTimeTravel =
            readerProfile.inventory.bookOfTimeTravel + reward.value;
        } else {
          readerProfile.inventory.bookOfTimeTravel = reward.value;
        }
      }

      if (reward.type === 'bookOfQuest') {
        if (
          readerProfile.inventory.bookOfQuest &&
          typeof readerProfile.inventory.bookOfQuest === 'number'
        ) {
          readerProfile.inventory.bookOfQuest =
            readerProfile.inventory.bookOfQuest + reward.value;
        } else {
          readerProfile.inventory.bookOfQuest = reward.value;
        }
      }

      if (reward.type === 'wordPotion') {
        if (
          readerProfile.inventory.wordPotion &&
          typeof readerProfile.inventory.wordPotion === 'number'
        ) {
          readerProfile.inventory.wordPotion =
            readerProfile.inventory.wordPotion + reward.value;
        } else {
          readerProfile.inventory.wordPotion = reward.value;
        }
      }

      if (reward.type === 'coupon') {
        if (!readerProfile.coupons) {
          readerProfile.coupons = [];
        }

        const couponData = {
          value: reward.value,
          id: uuidv4(),
        };
        readerProfile.coupons.push(couponData);
      }
      readerProfile.scratchCard = 'none';
      updateDocument(
        'demoReaders',
        readerId,
        readerProfile,
        auth.currentUser,
      ).then((resUpdate) => {
        if (!resUpdate.success) {
          toast.error("Something went wrong. Couldn't update the cloud");
          return;
        }
        toast.success('Reward Claimed');

        setTimeout(() => {
          onClose();
        }, 1000);
      });
    });
  };

  // --- 1. Preload Images ---
  useEffect(() => {
    const imagesToLoad = [frontImgUrl, backImgUrl, scratchSurfaceUrl];
    let loadedCount = 0;

    const checkLoad = () => {
      loadedCount++;
      if (loadedCount === imagesToLoad.length) {
        setIsLoading(false);
        setIsSpinning(true);
      }
    };

    imagesToLoad.forEach((src) => {
      const img = new Image();
      img.onload = checkLoad;
      img.onerror = checkLoad;
      img.src = src;
    });
  }, []);

  // --- 2. Handle Animation Timer ---
  useEffect(() => {
    if (isSpinning) {
      const timer = setTimeout(() => {
        setIsSpinning(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSpinning]);

  // --- 3. Initialize Canvas & Scratch Logic ---
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.scale(dpr, dpr);

    // --- SMART IMAGE LOADER ---
    const loadImageForCanvas = () => {
      // Try to load with CORS first, but if it fails, fallback gracefully
      const imgCORS = new Image();
      imgCORS.crossOrigin = 'Anonymous';

      imgCORS.onload = () => {
        ctx.drawImage(imgCORS, 0, 0, width, height);
      };

      imgCORS.onerror = () => {
        console.warn('CORS load failed. Fallback to non-CORS image.');
        // Fallback: Load without CORS.
        // This makes the canvas "tainted", but our Grid Workaround doesn't care!
        const imgFallback = new Image();
        imgFallback.onload = () => {
          ctx.drawImage(imgFallback, 0, 0, width, height);
        };
        imgFallback.onerror = () => {
          ctx.fillStyle = '#C0C0C0';
          ctx.fillRect(0, 0, width, height);
        };
        // Add timestamp to bypass cache
        imgFallback.src = scratchSurfaceUrl + '&t=' + new Date().getTime();
      };

      imgCORS.src = scratchSurfaceUrl;
    };

    loadImageForCanvas();

    // --- Scratching Logic ---
    let isDrawing = false;
    let lastPoint = null;

    const getBrushPos = (e) => {
      const rect = canvas.getBoundingClientRect();
      let clientX, clientY;

      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        clientX = e.clientX;
        clientY = e.clientY;
      }
      return { x: clientX - rect.left, y: clientY - rect.top };
    };

    // --- GRID WORKAROUND LOGIC ---
    // Instead of reading pixels (which fails with CORS), we track touched grid cells.
    const GRID_SIZE = 20; // 20px x 20px grid cells (approx brush size)
    const cols = Math.ceil(width / GRID_SIZE);
    const rows = Math.ceil(height / GRID_SIZE);
    const totalSegments = cols * rows;

    const trackScratchProgress = (x, y) => {
      if (isRevealedRef.current) return;

      // Calculate which grid cell we are touching
      const col = Math.floor(x / GRID_SIZE);
      const row = Math.floor(y / GRID_SIZE);

      // Safety check boundaries
      if (col >= 0 && col < cols && row >= 0 && row < rows) {
        const segmentId = `${col}-${row}`;
        scratchedGridRef.current.add(segmentId);

        const coveredPercentage =
          (scratchedGridRef.current.size / totalSegments) * 100;

        if (coveredPercentage > 25) {
          isRevealedRef.current = true;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          handleReward();
        }
      }
    };

    const startScratch = (e) => {
      if (isSpinning || isLoading) return;

      setHasScratched(true);
      isDrawing = true;
      lastPoint = getBrushPos(e);
      scratch(lastPoint);
      trackScratchProgress(lastPoint.x, lastPoint.y);
    };

    const moveScratch = (e) => {
      if (!isDrawing) return;
      e.preventDefault();
      const currentPoint = getBrushPos(e);
      scratch(currentPoint);
      lastPoint = currentPoint;
      trackScratchProgress(currentPoint.x, currentPoint.y);
    };

    const endScratch = () => {
      isDrawing = false;
      lastPoint = null;
    };

    const scratch = (pos) => {
      if (isRevealedRef.current) return;

      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, 20, 0, Math.PI * 2, false);
      ctx.fill();

      if (lastPoint) {
        ctx.beginPath();
        ctx.lineWidth = 40;
        ctx.lineCap = 'round';
        ctx.moveTo(lastPoint.x, lastPoint.y);
        ctx.lineTo(pos.x, pos.y);
        ctx.stroke();
      }
    };

    canvas.addEventListener('mousedown', startScratch);
    canvas.addEventListener('mousemove', moveScratch);
    canvas.addEventListener('mouseup', endScratch);
    canvas.addEventListener('mouseleave', endScratch);
    canvas.addEventListener('touchstart', startScratch, { passive: false });
    canvas.addEventListener('touchmove', moveScratch, { passive: false });
    canvas.addEventListener('touchend', endScratch);

    return () => {
      canvas.removeEventListener('mousedown', startScratch);
      canvas.removeEventListener('mousemove', moveScratch);
      canvas.removeEventListener('mouseup', endScratch);
      canvas.removeEventListener('mouseleave', endScratch);
      canvas.removeEventListener('touchstart', startScratch);
      canvas.removeEventListener('touchmove', moveScratch);
      canvas.removeEventListener('touchend', endScratch);
    };
  }, [isSpinning, isLoading, scratchSurfaceUrl]);

  useEffect(() => {
    const rewardsTable =
      tier === 'gold'
        ? goldRewardsTable
        : tier === 'silver'
          ? silverRewardsTable
          : bronzeRewardsTable;
    const randomNumber = Math.floor(Math.random() * rewardsTable.length);

    setReward(rewardsTable[randomNumber]);
  }, []);

  return (
    <div className='scratch-overlay'>
      {isLoading && <div className='loading-text'>Loading Card...</div>}

      {/* We hide the card with opacity:0 until loaded, so it doesn't show in the wrong state */}
      <div
        className={`card-container ${isSpinning ? 'spinning' : ''}`}
        ref={containerRef}
        style={{ opacity: isLoading ? 0 : 1 }}>
        {/* --- Back Face (Decorative) --- */}
        <div className='card-face card-back'>
          <img src={backImgUrl} alt='Card Back' />
        </div>

        {/* --- Front Face (Game) --- */}
        <div className='card-face card-front'>
          {/* Base Image (The Frame) */}
          <img src={frontImgUrl} className='front-bg' alt='Prize Base' />

          {/* Scratch Zone */}
          <div className='scratch-zone'>
            {reward && (
              <div
                className='prize-layer'
                style={{ visibility: hasScratched ? 'visible' : 'hidden' }}>
                <div className='prize-text'>
                  <img
                    src={rewardImg[reward.type]}
                    alt='reward image'
                    className='scratch-card-reward-image'
                  />

                  <p
                    style={{
                      fontSize: '20px',
                      textAlign: 'center',
                      margin: '-5px auto',
                    }}>
                    {reward.value} {reward.name}
                  </p>
                </div>
              </div>
            )}

            <canvas ref={canvasRef} className='scratch-canvas' />
          </div>
        </div>
      </div>
    </div>
  );
};
